import { CardDateType } from '@core/enums/card/card-date-type.enum';
import { CardType } from '@core/enums/card/card-type.enum';
import { CardValidityType } from '@core/enums/card/card-validity-type.enum';
import { ICardItem } from '@core/interfaces/card/card-item-interface';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { Currency } from '@interticket/core';

export const CARD_ITEM_1: ICardItem = {
  id: '5b9142b2-3671-4de6-a982-e29104befad6',
  cardType: CardType.GIFTCARD,
  name: 'Mock Gift Card',
  shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis molestie lorem auctor accumsan. Integer convallis non elit id placerat. Sed et bibendum sapien, ac condimentum libero. In tempus nulla dui, ac sodales velit cursus sed. Donec sed odio libero. ',
  imageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
  validity: {
    type: CardValidityType.EXPIRY_AFTERSALE,
    length: 100,
  },
  visibility: {
    type: CardDateType.WEB,
    enabled: true,
    from: '2021-07-01T00:00:00Z',
  },
  onSale: {
    type: CardDateType.WEB,
    enabled: false,
  },
  denominations: [
    {
      value: 1000,
      currency: Currency.HUF,
    },
    {
      value: 5000,
      currency: Currency.HUF,
    },
    {
      value: 10000,
      currency: Currency.HUF,
    },
    {
      value: 20000,
      currency: Currency.HUF,
    },
  ],
};

export const CARD_ITEM_2: ICardItem = {
  id: '44f1ed67-0654-4787-85af-831f8c9936a9',
  cardType: CardType.GIFTCARD,
  name: 'Second Mock Gift Card',
  shortDescription: 'Praesent vulputate felis arcu, at tempus arcu viverra sed. Quisque egestas mi non consectetur hendrerit.',
  imageId: 'ae3b8837-eb6a-4ecf-ada4-2c62c73e3c63',
  validity: {
    type: CardValidityType.FROM_TO,
    from: '2021-08-01T00:00:00Z',
    to: '2021-12-31T23:59:59Z',
  },
  visibility: {
    type: CardDateType.WEB,
    enabled: true,
    from: '2021-07-01T00:00:00Z',
    to: '2022-12-31T00:00:00Z',
  },
  onSale: {
    type: CardDateType.WEB,
    enabled: true,
    from: '2021-08-01T00:00:00Z',
    to: '2021-10-31T00:00:00Z',
  },
  denominations: [
    {
      value: 1000,
      currency: Currency.HUF,
    },
  ],
};

export const CARD_LIST: IListResult<ICardItem> = {
  resultsLength: 3,
  results: [
    CARD_ITEM_1,
    CARD_ITEM_2,
    CARD_ITEM_1,
    CARD_ITEM_2,
    CARD_ITEM_1,
  ],
};
